'use client';
import styles from '../linkInfoCard.module.scss';
import SXMLink from '@/shared-components/SXMLink';
import { convertContentToLinkTarget as setTarget } from '@/packages/linkHandler';
import ArrowRightIcon from '@/assets/icons/icon-arrow-right.svg';
import cn from 'classnames';
import { useEffect, useRef } from 'react';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

export interface LinkInfoItemProps {
    link: Link;
    disabled: boolean;
    icon: {
        url?: string;
        width?: number;
        height?: number;
    };
    onClick?: React.MouseEventHandler;
}

export default function LinkInfoItem({ link, icon, disabled, onClick }: LinkInfoItemProps) {
    const ref = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        const buttonRef = ref.current;
        const handleKeyDown = (e: KeyboardEvent) => e.key === 'Enter' && e.preventDefault();

        if (buttonRef && disabled) {
            buttonRef.addEventListener('keydown', handleKeyDown);
        }

        return () => buttonRef?.removeEventListener('keydown', handleKeyDown);
    }, [disabled]);

    const classes = cn(styles.row, {
        [styles.disabled]: disabled,
    });

    if (link.href) {
        return (
            <SXMLink
                ref={ref}
                className={classes}
                href={link.href}
                aria-label={link.aria_label}
                target={setTarget(link.link_target)}
                aria-disabled={disabled}
                onClick={onClick}
            >
                {icon.url && (
                    <ImageWrapper src={icon.url} alt="" optimizedHeight={icon.height} optimizedWidth={icon.width} />
                )}
                {link.link_text}
                <span className={styles.arrow}>
                    <ArrowRightIcon />
                </span>
            </SXMLink>
        );
    }

    return (
        <button ref={ref} className={classes} aria-label={link.aria_label} aria-disabled={disabled} onClick={onClick}>
            {icon.url && (
                <ImageWrapper src={icon.url} alt="" optimizedHeight={icon.height} optimizedWidth={icon.width} />
            )}
            {link.link_text}
            <span className={styles.arrow}>
                <ArrowRightIcon />
            </span>
        </button>
    );
}
